<template>
  <router-view/>
</template>

<script>
import Utils from '@/utils/Utils'

import PublicLayout from '@/layouts/PublicLayout'

export default {
  name: 'App',

  components: {
    PublicLayout
  },

  methods: {
    /**
     * Read token and user data from local storage. If they exist, we set the
     * `Authorization: Bearer` token, and trigger the Vuex action that will
     * check if the token is valid and not expired, so we can log the user in
     * automatically
     */
    validateToken () {
      const { apiToken, userData } = Utils.getApiToken()

      if (apiToken && userData) {
        Utils.setApiToken(apiToken, userData)
        this.$store.dispatch('validateToken', { apiToken, userData })
      }
    }
  },

  beforeCreate () {},

  created () {
    this.validateToken()
  }
}
</script>

<style lang="scss">
@import '../node_modules/bulma/sass/utilities/initial-variables';
@import '../node_modules/bulma/sass/utilities/mixins';
@import '../node_modules/bulma/sass/utilities/functions';
@import "./assets/css/bulma-overwrites";
// @import '../node_modules/bulma/sass/grid/_all';
@import '../node_modules/bulma/bulma';

@import "./assets/css/styles";

#app {
  color: $color-text-light;
}

</style>



// WEBPACK FOOTER //
// src/App.vue